import { faFacebookSquare, faInstagramSquare, faLinkedin, faYoutubeSquare } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FormForgotPassword from './FormForgotPassword';
import FormLogin from './FormLogin';
import './login.scss';

function move(id: string){
  let element = document.getElementById(id);
  if(element){
    if(element.classList.contains("side-right")){
      element.className = element.className.replace("side-right","side-left moving-side-left");
    } else if(element.classList.contains("side-left")){
      element.className = element.className.replace("side-left","side-right moving-side-right");
    }
    setTimeout(()=>{
      if(element){
        element.className = element.className.replace(" moving-side-right","");
        element.className = element.className.replace(" moving-side-left","");
      }
    },750);
  }
}

export default function Login(){

  document.title = "Login";

  return <div id="background-login" style={{backgroundImage:'url("./images/background-login.png")'}}>
    <div id="card-center-login">
      <div id="side-form" className="side-left">
        <div id="side-form-area">
          <div id="side-form-area2">
            <FormLogin move={()=>{
              move("side-form");
              move("side-background-move");
            }}/>
          </div>
          <div id="side-form-area2">
            <FormForgotPassword move={()=>{
              move("side-form");
              move("side-background-move");
            }}/>
          </div>
        </div>
        <div id="logo-sim-trend">
          <img alt="logo-sim-trend" src="./images/sim-trend-logo.png"></img>
        </div>
      </div>
      <div id="side-background-move" className="side-right" >
        <div id="side-background-area">
          <div id="side-background-image" style={{backgroundImage:'url("./images/background-login.png")'}}>
          </div>
          <div id="sim-logo-side-background">
            <img alt="sim-logo-side-background" src="./images/sim-logo.png"></img>
            <div id="sim-logo-side-background-sub">Sistema Integrado de Marketing</div>
            <div id="sim-logo-side-background-text">Plataforma digital para a gestão e o controle das verbas de Marketing</div>
          </div>
          <div id="side-background-social-media-icons">
            <a href="#1"><FontAwesomeIcon icon={faLinkedin} /></a>
            <a href="#2"><FontAwesomeIcon icon={faFacebookSquare} /></a>
            <a href="#3"><FontAwesomeIcon icon={faInstagramSquare} /></a>
            <a href="#4"><FontAwesomeIcon icon={faYoutubeSquare} /></a>
          </div>
        </div>
      </div>
    </div>
  </div>
}